import { render, staticRenderFns } from "./VLeadTransitions.vue?vue&type=template&id=06907c74"
import script from "./VLeadTransitions.vue?vue&type=script&lang=js"
export * from "./VLeadTransitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports